
import { useState, useEffect, useRef } from "react";
import { Music, BarChart3, Award, Radio } from "lucide-react";

const AboutYouAuxSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const services = [
    {
      icon: <Music className="h-8 w-8 text-ophira-yellow" />,
      title: "Music Distribution",
    },
    {
      icon: <Award className="h-8 w-8 text-ophira-yellow" />,
      title: "Royalty Collection",
    },
    {
      icon: <Radio className="h-8 w-8 text-ophira-yellow" />,
      title: "Artist Promotion",
    },
    {
      icon: <BarChart3 className="h-8 w-8 text-ophira-yellow" />,
      title: "Analytics Dashboard",
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-black relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-ophira-yellow/10 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-ophira-yellow/10 to-transparent"></div>
      </div>
      
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
          }`}>
            <div className="ophira-section-label">ABOUT YOUAUX</div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white uppercase tracking-tight leading-tight">
              THE MODERN WAY TO DISTRIBUTE YOUR MUSIC TO THE WORLD
            </h2>
            <p className="text-white/65 text-lg mb-6 leading-relaxed">
              YouAux is a comprehensive music distribution platform that helps independent 
              artists reach a global audience. Our mission is to empower musicians by 
              providing the tools and services they need to succeed in today's digital music 
              landscape, all while keeping 100% ownership of their music.
            </p>
          </div>
          
          <div className={`grid grid-cols-1 gap-6 transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
          }`}>
            {services.map((service, index) => (
              <div 
                key={index} 
                className="flex items-center gap-4 bg-ophira-darkgray/30 border border-ophira-darkgray/70 p-6 hover:bg-ophira-darkgray/50 transition-all rounded-[0.65rem] duration-300"
              >
                <div className="bg-black/50 rounded-full p-4">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-white">{service.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutYouAuxSection;
